/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "~/backend/axiosClient"
import type {
  TransferManyCertificateRequestsMutationRequest,
  TransferManyCertificateRequestsMutationResponse,
} from "../types/TransferManyCertificateRequests.ts"
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"
import { mutationOptions, useMutation } from "@tanstack/react-query"

export const transferManyCertificateRequestsMutationKey = () =>
  [
    { url: "/v1/certificate-request/transfer-many-certificate-requests" },
  ] as const

export type TransferManyCertificateRequestsMutationKey = ReturnType<
  typeof transferManyCertificateRequestsMutationKey
>

/**
 * @summary Transfer many certificate requests
 * {@link /v1/certificate-request/transfer-many-certificate-requests}
 */
export async function transferManyCertificateRequests(
  data: TransferManyCertificateRequestsMutationRequest,
  config: Partial<
    RequestConfig<TransferManyCertificateRequestsMutationRequest>
  > & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    TransferManyCertificateRequestsMutationResponse,
    ResponseErrorConfig<Error>,
    TransferManyCertificateRequestsMutationRequest
  >({
    method: "POST",
    url: `/v1/certificate-request/transfer-many-certificate-requests`,
    data: requestData,
    ...requestConfig,
  })
  return res
}

export function transferManyCertificateRequestsMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<TransferManyCertificateRequestsMutationRequest>
  > & { client?: Client } = {}
) {
  const mutationKey = transferManyCertificateRequestsMutationKey()
  return mutationOptions<
    ResponseConfig<TransferManyCertificateRequestsMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: TransferManyCertificateRequestsMutationRequest },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ data }) => {
      return transferManyCertificateRequests(data, config)
    },
  })
}

/**
 * @summary Transfer many certificate requests
 * {@link /v1/certificate-request/transfer-many-certificate-requests}
 */
export function useTransferManyCertificateRequests<TContext>(
  options: {
    mutation?: UseMutationOptions<
      ResponseConfig<TransferManyCertificateRequestsMutationResponse>,
      ResponseErrorConfig<Error>,
      { data: TransferManyCertificateRequestsMutationRequest },
      TContext
    > & { client?: QueryClient }
    client?: Partial<
      RequestConfig<TransferManyCertificateRequestsMutationRequest>
    > & { client?: Client }
  } = {}
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey =
    mutationOptions.mutationKey ?? transferManyCertificateRequestsMutationKey()

  const baseOptions = transferManyCertificateRequestsMutationOptions(
    config
  ) as UseMutationOptions<
    ResponseConfig<TransferManyCertificateRequestsMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: TransferManyCertificateRequestsMutationRequest },
    TContext
  >

  return useMutation<
    ResponseConfig<TransferManyCertificateRequestsMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: TransferManyCertificateRequestsMutationRequest },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient
  ) as UseMutationResult<
    ResponseConfig<TransferManyCertificateRequestsMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: TransferManyCertificateRequestsMutationRequest },
    TContext
  >
}
